export const roles = [
  { label: 'Accountant', value: 'Accountant' },
  { label: 'Marketer', value: 'Marketer' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Administrator', value: 'Administrator' }
];
